import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Children } from 'react';
import { stripIndent } from '../../../helpers/stripIndent';
export const findFragments = children => {
  const fragments = {};
  const fragmentNodes = Children.toArray(children).filter( // eslint-disable-next-line @typescript-eslint/no-explicit-any
  node => node.type._type === 'frag');
  fragmentNodes.forEach((el, index) => {
    const element = el;
    const Frag = element.type;
    const props = element.props;

    const code = props.code,
          inline = props.inline,
          otherProps = _objectWithoutProperties(props, ["code", "inline"]);

    const stripedCode = typeof code === 'string' && !inline ? stripIndent(code) : code;
    fragments[props.id] = {
      element: React.createElement(Frag, Object.assign({
        key: props.id + index
      }, otherProps, {
        code: stripedCode,
        inline: inline,
        index: props.in
      })),
      inline: !!props.inline
    };
  });
  return fragments;
};